import type { IRecord } from '@platform/core/types';
import { normalizeValue } from '../draftChanges';
import { valueOf } from '../valueOf';

/**
 * Значення POST нового запису: основа (типові й наперед задані) + чернетка, з назвою й статусом; користувачі — ідентифікатори,
 * порожні значення не надсилаються; теги йдуть окремо. Чиста функція.
 */
export function newRecordValues(record: IRecord, draft: Record<string, unknown>): Record<string, unknown> {
  const merged: Record<string, unknown> = { ...record.values, ...draft, title: valueOf(record, draft, 'title'), status: valueOf(record, draft, 'status') };
  delete merged['tags'];
  return Object.fromEntries(Object.entries(merged).map(([k, v]) => [k, normalizeValue(v)] as const).filter(([, v]) => v !== null));
}
